<section class="mu-home">
  <div class="container">
    <div class="row" *ngIf="userDashboardDetails$ | async as dashboardState">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-md-8 col-12">
              <div class="d-flex align-items-center indpg-tptxt">
                <h3>{{ companyName }}</h3>
                <span (click)="openClientSelector()">CHANGE</span>
              </div>
              <div class="row align-items-center pt-2 g-0">
                <div class="col-6 dwnlefttind">
                  <app-greeting></app-greeting>
                </div>
                <div class="row" style="text-align: right; padding-right: 0">
                  <div class="col-6"></div>
                  <div class="col-3" style="padding: 0">
                    <app-select-period-selector
                      class="d-flex align-items-center justify-content-end dwnrightind"
                      (dataEvent)="handleViewForData($event)"></app-select-period-selector>
                  </div>
                  <div class="col-3" style="padding: 0">
                    <button type="button" class="btn btn-primary" (click)="openEntityWiseInfoModal()">
                      Entity Info
                    </button>
                  </div>
                </div>
              </div>

              <div class="row align-items-center pb-2">
                <div class="col-12" *ngFor="let statistics of dashboardState?.statistics">
                  <div
                    class="row mx-0 my-2"
                    [ngClass]="
                      statistics.type == statisticsType.ACTIVITY
                        ? 'main-boxone'
                        : statistics.type == statisticsType.QUERY
                        ? 'main-boxthree'
                        : 'main-boxtwo'
                    ">
                    <div class="col-md-8 col-12 left-cont-boxx">
                      <h3>
                        {{
                          statistics.type == 'Newjoinee Activity'
                            ? 'New joinee Activity'
                            : statistics.type == 'Government Business'
                            ? 'Government Business Tasks'
                            : statistics.type == 'Queries'
                            ? 'Employee Queries'
                            : ''
                        }}
                      </h3>
                      <h2>{{ statistics.percentage }}%</h2>
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          [style.width.%]="statistics.percentage"
                          aria-valuenow="75"
                          aria-valuemin="0"
                          aria-valuemax="100"></div>
                      </div>
                    </div>
                    <div class="col-md-2 col-6 text-center right-cont-boxx">
                      <div [ngClass]="statistics.type == statisticsType.ACTIVITY ? '' : 'bg-white'">
                        <h3>{{ statistics.totalCount }}</h3>
                        <p>TOTAL</p>
                      </div>
                    </div>
                    <div class="col-md-2 col-6 text-center right-cont-boxx">
                      <div [ngClass]="statistics.type == statisticsType.ACTIVITY ? '' : 'bg-white'">
                        <h3>{{ statistics.toDoCount }}</h3>
                        <p>TO DO</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 cursor" style="margin-top: 10px">
                  <div class="row g-2 ind-link-right">
                    <div class="col-6" [routerLink]="ACTIVITY_DASHBOARD">
                      <div class="ilrp"><a>Activity Board</a></div>
                    </div>
                    <div class="col-6" [routerLink]="GOVERNMENT_BUSINESS_DASHBOARD">
                      <div class="ilrp"><a>GB Tracker</a></div>
                    </div>
                    <div class="col-6" [routerLink]="QUERY_DASHBOARD">
                      <div class="ilrp"><a>Employee Queries</a></div>
                    </div>
                    <div class="col-6" [routerLink]="REPOSITORY">
                      <div class="ilrp"><a>Data Repository</a></div>
                    </div>
                    <div class="col-6" [routerLink]="EMPLOYEE">
                      <div class="ilrp"><a>Employee Summary</a></div>
                    </div>
                    <div class="col-6" [routerLink]="CALENDER">
                      <div class="ilrp"><a>Calendar Info</a></div>
                    </div>
                    <div class="col-6" [routerLink]="ANNOUNCEMENT">
                      <div class="ilrp"><a>Announcement & Circulars</a></div>
                    </div>
                    <div
                      *ngIf="(user$ | async)?.userType !== 'EMPLOYEE_ADMIN'"
                      class="col-6"
                      [routerLink]="PENDING_ITEM">
                      <div class="ilrp"><a>Pending Items</a></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-12 ind-rightbox">
              <div class="col-12 text-end mb-2 right-sidetptxt">
                <h3>Total Head Count {{ dashboardState.totalHeadCount }}</h3>
              </div>
              <div class="col-12 p-2 mb-3 right-notfctn">
                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.875 1.6253V5.80533C15.3959 6.10857 15.75 6.66639 15.7497 7.31278C15.7497 7.95891 15.3956 8.51673 14.8747 8.81997V13C14.8747 13.2521 14.6811 13.875 13.9997 13.875C13.7934 13.8748 13.603 13.8028 13.4534 13.6831L11.1283 11.8229C9.96076 10.8893 8.49459 10.375 6.99998 10.375H6.23217C6.15588 10.6542 6.11158 10.9462 6.11158 11.25C6.11158 12.0452 6.37818 12.7791 6.82663 13.3675C7.25839 13.9341 6.83071 14.75 6.11842 14.75H3.21235C2.88748 14.75 2.57768 14.5758 2.43578 14.2835C1.99008 13.365 1.73686 12.3375 1.73686 11.25L1.75 10.375C0.783407 10.375 0 9.5916 0 8.62501V6.00002C0 5.03343 0.783407 4.25002 1.75 4.25002H6.99998C8.49459 4.25002 9.96076 3.7357 11.1286 2.80217L13.4536 0.94197C13.6119 0.815105 13.8053 0.750031 14 0.750031H14.0002C14.6841 0.750031 14.875 1.38604 14.875 1.6253ZM3.04936 11.25C3.04936 12.0072 3.19838 12.7416 3.49262 13.4375H5.32436C4.97901 12.7649 4.79908 12.0216 4.79908 11.25C4.79908 10.9604 4.8382 10.6676 4.89535 10.375H3.12046L3.11269 10.4328C3.08753 10.6183 3.04936 10.8998 3.04936 11.25ZM6.56248 9.06251H1.75C1.50882 9.06251 1.3125 8.86619 1.3125 8.62501V6.00002C1.3125 5.75884 1.50882 5.56252 1.75 5.56252H6.56248V9.06251ZM11.9481 10.7977L13.5625 12.0895V2.53557L11.9484 3.82702C10.7778 4.76298 9.35619 5.34131 7.87498 5.50756V9.11747C9.35619 9.28372 10.7778 9.86205 11.9481 10.7977Z"
                    fill="#0452D7" />
                </svg>
                <span>Announcements</span>
                <div class="notification-scroll-card">
                  <p *ngFor="let announcement of dashboardState.announcements" class="cursor pad-top-15">
                    <a (click)="displayNotificationDetails(announcement)">
                      <ng-container *ngIf="announcement.taskSubCategory">
                        [{{ announcement.taskSubCategory }}] -
                      </ng-container>
                      {{ announcement.heading }}</a
                    >
                  </p>
                </div>
              </div>
              <div class="col-12 px-0 mb-3 right-clndr">
                <!--<div id="pb-calendar" class="pb-calendar"></div>-->
                <div class="row text-center mx-0 cal-hed">
                  <div class="col-md-2 cal-hed-first">
                    <div class="btn-group">
                      <div
                        class="cursor"
                        mwlCalendarPreviousView
                        [view]="view"
                        [(viewDate)]="viewDate"
                        (viewDateChange)="closeOpenMonthViewDay()">
                        <img src="./assets/images/prev.png" class="img-fluid pre-next" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8 cal-hed-second">
                    <h3>{{ viewDate | calendarDate : view + 'ViewTitle' : 'en' }}</h3>
                  </div>
                  <div class="col-md-2 cal-hed-third">
                    <div
                      class="cursor"
                      mwlCalendarNextView
                      [view]="view"
                      [(viewDate)]="viewDate"
                      (viewDateChange)="closeOpenMonthViewDay()">
                      <img src="./assets/images/next.png" class="img-fluid pre-next" />
                    </div>
                  </div>
                </div>

                <div [ngSwitch]="view">
                  <mwl-calendar-month-view
                    *ngSwitchCase="CalendarView.Month"
                    [viewDate]="viewDate"
                    [weekStartsOn]="1"
                    [events]="events"
                    [refresh]="refresh"
                    (eventClicked)="openEventDetailsPopup($event)"
                    [activeDayIsOpen]="activeDayIsOpen">
                    >
                  </mwl-calendar-month-view>
                </div>
                <div class="legend">
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #1e90ff"></span>
                    Activity
                  </div>
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #e3bc08"></span>
                    Events
                  </div>
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #ad2121"></span>
                    GB
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div
  class="modal fade"
  id="view-notification-modal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  *ngIf="dashboard.displayAnnouncementModel.show">
  <div class="side-nav">
    <mat-card>
      <mat-card-header>
        <div class="row mx-0 py-2">
          <div class="col-lg-12 p-2 mb-3">
            <img
              src="../../../assets/images/svg/modal-cross.svg"
              class="close-icon"
              (click)="closeAnnouncementPopup()" />
            <img src="../../../assets/images/svg/notification-icon.svg" class="notification-icon" />
            <span class="heading-cnt">Announcements</span>
          </div>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div>
          <p class="heading">{{ dashboard.displayAnnouncementModel.title }}</p>
        </div>
        <div>
          <p class="description" [innerHTML]="dashboard.displayAnnouncementModel.content"></p>
        </div>
        <div class="notification-pdf" *ngIf="dashboard?.displayAnnouncementModel?.isAttachmentDocumentAvailable">
          <div class="d-flex" *ngFor="let attachment of dashboard.displayAnnouncementModel.attachments">
            <img src="assets/images/svg/Shape.svg " class="notification-pdficon" />
            <a (click)="downloadDocument(attachment, dashboard.displayAnnouncementModel.companyId)" class="pdf-link">{{
              attachment.name
            }}</a>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div
  class="modal fade"
  id="view-notification-modal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  *ngIf="dashboard.displayCalendarModel.show">
  <div class="side-nav">
    <mat-card>
      <mat-card-header>
        <div class="row py-2">
          <div class="col-lg-12 p-2 mb-3">
            <img src="../../../assets/images/svg/modal-cross.svg" class="close-icon" (click)="closeCalendarPopup()" />
            <img src="../../../assets/images/svg/calendar-icon.svg" class="calendar-icon" />
            <span class="heading-calendar">Calendar</span>
            <div class="row py-2">
              <div class="col-lg-12 heading-calendar">
                {{ dashboard.displayCalendarModel.date | date : 'd MMMM y' }}
              </div>
            </div>
          </div>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div>
          <p class="heading">{{ dashboard.displayCalendarModel.title }}</p>
        </div>
        <div *ngFor="let data of dashboard.displayCalendarModel.content">
          <p class="description">
            <ng-container *ngIf="data?.displayDescription?.split(':')[0] && data?.referenceDisplayId; else plainText">
              <span
                [innerHTML]="
                  data?.displayDescription?.split(':')[0] +
                  '(' +
                  generateLink(data) +
                  ') - ' +
                  data?.displayDescription?.split(':')[1]
                "></span>
            </ng-container>
            <ng-template #plainText>
              {{ data?.displayDescription }}
            </ng-template>
          </p>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="isEnitiyWiseInfoVisible">
  <div>
    <app-entity-wise-info [isVisible]="isEnitiyWiseInfoVisible" (close)="closeEntityWiseInfoModal()">
    </app-entity-wise-info>
  </div>
</div>
